export default "__VITE_ASSET__UhGTYp2s__"